import {
  Map as ImmutableMap,
  List as ImmutableList,
} from 'immutable'
import {
  BUSINESS_EDITOR_RESET,
  BUSINESS_EDITOR_ATTR_CHANGE,
  BUSINESS_EDITOR_SETUP,
} from '../actions/business_editor'

const initialState = ImmutableMap({
  businessId: null,
  isSubmitting: false,
  isChanged: false,
  attrs: ImmutableMap({
    name: '',
    tagline: '',
    description: '',
    phone: '',
    websites: [],
    categories: [],
    cta_title: '',
    cta_link: '',
    logo: null,
    cover: null,
    is247: false,
    location: null,
    account_hidden: -1, // -1 on load until businessAccount sets it
    hours: {
      mon: { o: '', c: '' },
      tue: { o: '', c: '' },
      wed: { o: '', c: '' },
      thur: { o: '', c: '' },
      fri: { o: '', c: '' },
      sat: { o: '', c: '' },
      sun: { o: '', c: '' }
    },
    // coupons: [],
  }),
})

const helperToJS = (obj) => {
  return !!obj && (ImmutableMap.isMap(obj) || ImmutableList.isList(obj)) ? obj.toJS() : null
}

export default function business_editor(state = initialState, action) {
  switch(action.type) {
  case BUSINESS_EDITOR_SETUP:
    return state.withMutations((map) => {
      if (action.business) {
        map.set('businessId', action.business.get('id'))
        map.setIn(['attrs', 'name'], action.business.get('name'))
        map.setIn(['attrs', 'tagline'], action.business.get('tagline'))
        map.setIn(['attrs', 'description'], action.business.get('description'))
        map.setIn(['attrs', 'websites'], helperToJS(action.business.get('websites')))
        map.setIn(['attrs', 'categories'], helperToJS(action.business.get('categories')))
        map.setIn(['attrs', 'cta_title'], action.business.getIn(['cta', 'title']))
        map.setIn(['attrs', 'cta_link'], action.business.getIn(['cta', 'link']))
        map.setIn(['attrs', 'logo'], action.business.get('logo_thumbnail_url'))
        map.setIn(['attrs', 'cover'], action.business.get('cover_image_url'))
        map.setIn(['attrs', 'phone'], action.business.get('phone_number'))
        map.setIn(['attrs', 'location'], helperToJS(action.business.get('locations')))
      }
      map.setIn(['attrs', 'isSubmitting'], false)
    })
  case BUSINESS_EDITOR_RESET:
    return initialState
  case BUSINESS_EDITOR_ATTR_CHANGE:
    return state.withMutations((map) => {
      map.setIn(['attrs', action.business_key], action.business_value)
      map.set('isChanged', true)
    })
  default:
    return state
  }
}
